import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=313eaeac&scoped=true"
import script from "./Metric.vue?vue&type=script&lang=js"
export * from "./Metric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313eaeac",
  null
  
)

export default component.exports